import React from "react";

const styles = {
  container: {
    padding: "2rem",
    maxWidth: "900px",
    margin: "0 auto",
    fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
    lineHeight: "1.8",
    color: "#333",
  },
  header: {
    fontSize: "2rem",
    marginBottom: "1rem",
    color: "#1a1a1a",
    textAlign: "center",
  },
  sectionTitle: {
    fontSize: "1.4rem",
    marginTop: "1.8rem",
    marginBottom: "0.5rem",
    color: "#00539C",
  },
  paragraph: {
    fontSize: "1rem",
    marginBottom: "1rem",
  },
  strong: {
    fontWeight: "bold",
  },
  contact: {
    fontSize: "1rem",
    marginTop: "1.5rem",
    fontStyle: "italic",
  },
};

const PrivacyPolicy = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Privacy Policy for Staff Connect</h1>
      {/* <p style={styles.paragraph}><strong style={styles.strong}>Effective Date:</strong> [Insert Date]</p> */}

      <h2 style={styles.sectionTitle}>1. Information We Collect</h2>
      <p style={styles.paragraph}>
        We collect the following data with your permission:
        <br />• <strong style={styles.strong}>Location Data</strong>:
        ACCESS_FINE_LOCATION, ACCESS_COARSE_LOCATION, ACCESS_BACKGROUND_LOCATION
        – to provide location-based services.
        <br />• <strong style={styles.strong}>Camera Access</strong>: CAMERA –
        to capture and upload documents.
        <br />• <strong style={styles.strong}>Storage Access</strong>:
        READ/WRITE_EXTERNAL_STORAGE, MANAGE_EXTERNAL_STORAGE, READ_MEDIA_IMAGES,
        READ_MEDIA_VIDEO – to handle app files.
        <br />• <strong style={styles.strong}>Internet Access</strong>: INTERNET
        – to sync data with servers.
      </p>

      <h2 style={styles.sectionTitle}>2. How We Use Your Data</h2>
      <p style={styles.paragraph}>
        We use your data to:
        <br />• Provide features and services
        <br />• Improve app functionality
        <br />• Communicate with you
        <br />• Ensure legal compliance
        <br />
        <br />
        We <strong style={styles.strong}>do not</strong> sell or share your data
        for marketing.
      </p>

      <h2 style={styles.sectionTitle}>3. Data Sharing</h2>
      <p style={styles.paragraph}>
        Your data may be shared only:
        <br />• When required by law
        <br />• For essential app functions (e.g., server processing)
        <br />• To prevent fraud or abuse
      </p>

      <h2 style={styles.sectionTitle}>4. Data Security</h2>
      <p style={styles.paragraph}>
        We use secure systems and best practices to protect your data from
        unauthorized access.
      </p>

      <h2 style={styles.sectionTitle}>5. Children’s Privacy</h2>
      <p style={styles.paragraph}>
        Staff Connect is not intended for children under 13. We do not knowingly collect
        information from children.
      </p>

      <h2 style={styles.sectionTitle}>6. Your Rights</h2>
      <p style={styles.paragraph}>
        You may control app permissions from your phone’s settings. Uninstalling
        the app will stop data collection.
      </p>

      <h2 style={styles.sectionTitle}>7. Changes to This Policy</h2>
      <p style={styles.paragraph}>
        This policy may change over time. Please review it periodically.
      </p>

      <h2 style={styles.sectionTitle}>8. Contact Us</h2>
      <p style={styles.contact}>
        For any questions, email us at{" "}
        <a
          href="mailto:Rayalbroker@gmail.com"
          style={{ color: "#00539C", textDecoration: "underline" }}
        >
          admin@mywsh.com.sg
        </a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
